// extracted by mini-css-extract-plugin
module.exports = {"mob-br":"mob-br__1YQYa","sp-br":"sp-br__3uzwS","non-sp-br":"non-sp-br__6bq5V"};